import { z } from "zod";
export const npdIngredientWithMixtureIdDtoSchema = z.object({
    id: z.number(),
    name: z.string(),
    value: z.number(),
    unit: z.string(),
    proportion: z.number(),
    mixtureId: z.number(),
});
